const transformDropdownOption = ({ label, ...values }) => ({
	label: Array.isArray(label) ? label.map(el => el.value).join('') : label,
	...values,
});

export default transformDropdownOption;
